<template>
  <div disabled>
    <b-card header="Kontainer">
      <b-button v-b-modal.modal-kontainer variant="success">
        <i class="fa fa-plus"></i> Tambah Kontainer
      </b-button>
      <modal-kontainer ref="modalKontainer" />
      <!-- TABEL View Kontainer -->
      <table class="table table-responsive table-sm table-striped mt-3" v-if="this.$store.state.barpin.kontainer.length">
        <thead>
          <tr>
            <th class="text-left">Nomor Kontainer</th>
            <th class="text-left">Ukuran Kontainer</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in this.$store.state.barpin.kontainer" :key="item.NO_KONTAINER">
            <td>{{ item.NO_KONTAINER}}</td>
            <td>{{ `${ item.UKURAN_KONTAINER } Feet / ${ item.JNS_KONTAINER }`}}</td>
            <td>
              <button class="btn btn-danger" @click="removeKontainer(item.ID_KONTAINER)">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <hr />
    <!-- TABEL KEMASAN -->
    <b-card header="Kemasan">
      <b-button v-b-modal.modal-kemasan variant="success" v-if="this.$store.state.barpin.kemasan.length < 1">
        <i class="fa fa-plus"></i> Tambah Kemasan
      </b-button>
      <table class="table table-responsive table-sm mt-3" v-if="this.$store.state.barpin.kemasan.length">
        <thead>
          <tr>
            <th>Jumlah Kemasan</th>
            <th>Jenis Kemasan</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in this.$store.state.barpin.kemasan" :key="index">
            <td>{{ item.JML_KMS }}</td>
            <td>{{ item.JNS_KMS }}</td>
            <td>
              <button @click="getDetilKemasan(item.ID_KEMASAN)" v-b-modal.modal-kemasan-edit class="btn btn-secondary"><i class="fa fa-edit"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <modal-kemasan ref="modalKemasan" />
    <modal-kemasan-edit ref="modalKemasanEdit" />
    <hr />
    <b-card header="Barang">
      <!-- BUTTON AND MODAL -->
      <b-button v-b-modal.modal-barang variant="success">
        <i class="fa fa-plus"></i> Tambah Barang
      </b-button>
      <!-- TABEL BARANG -->
      <table class="table table-responsive table-striped mt-3" v-if="this.$store.state.barpin.barang.length">
        <thead>
          <tr>
            <th class="text-left">Nama Barang</th>
            <th class="text-left">Jumlah Barang</th>
            <th class="text-left">Nilai Barang</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in this.$store.state.barpin.barang" :key="item.URAIAN_BARANG">
            <td>{{ item.URAIAN_BARANG}}</td>
            <td>{{ `${ item.JML_SATUAN } ${ item.JNS_SATUAN } / ${ item.JML_KEMASAN } ${ item.JNS_KEMASAN } `}}</td>
            <td>{{ item.CIF.toLocaleString()}}</td>
            <td>
              <button v-b-modal.modal-edit-barang class="btn btn-primary" @click="getDetilBarang(item.ID_BARANG)">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-danger" @click="removeBarang(item.ID_BARANG)">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <modal-barang ref="modalBarang" />
    <modal-edit-barang ref="modalEditBarang" />
  </div>
</template>
<script>
import ModalKontainer from '@/views/ppftz/modal/ModalKontainer.vue'
import ModalBarang from '@/views/ppftz/modal/ModalBarang.vue'
import ModalEditBarang from '../modal/ModalEditBarang.vue'
import ModalKemasan from '@/views/ppftz/modal/ModalKemasan.vue'
import ModalKemasanEdit from '@/views/ppftz/modal/ModalKemasanEdit.vue'
import {mapActions} from 'vuex'
import swal from 'sweetalert'
export default {
  components: {
    ModalKontainer, ModalBarang, ModalEditBarang, ModalKemasan, ModalKemasanEdit
  },
  created () {
    this.getKontainer(this.$store.state.barpin.header.id_aju)
    this.getBarang(this.$store.state.barpin.header.id_aju)
    this.getKemasan(this.$store.state.barpin.header.id_aju)
  },
  methods: {
    ...mapActions({
      getKontainer: 'barpin/getKontainer',
      getBarang: 'barpin/getBarang',
      getDetilBarang: 'barpin/getDetilBarang',
      getKemasan: 'barpin/getKemasan',
      getDetilKemasan: 'barpin/getDetilKemasan'
    }),
    removeBarang (index) {
      swal({
        title: 'Hapus data barang?',
        text: 'Anda yakin akan menghapus data barang ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.$store.dispatch('barpin/removeBarang', {ID_BARANG: index, ID_AJU: this.$store.state.barpin.header.id_aju})
          }
        })
    },
    removeKontainer (index) {
      swal({
        title: 'Hapus Kontainer?',
        text: 'Anda yakin akan menghapus kontainer ini?',
        icon: 'error',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.$store.dispatch('barpin/removeKontainer', {ID_KONTAINER: index, ID_AJU: this.$store.state.barpin.header.id_aju})
          }
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/Perekaman/Step-2.vue?9c6c5d54